document.addEventListener('DOMContentLoaded', function () {
    const contenedoresDescarga = document.querySelectorAll('.contDescargaReportes');

    if (contenedoresDescarga.length === 0) {
        return;
    }

    function inicializarDescargaReportes(contDescargaReportes) {
        const btnDescargarReportes = contDescargaReportes.querySelector('.btnDescargarReportes');
        const menuDescargaReportes = contDescargaReportes.querySelector('.menuDescargaReportes');

        if (!btnDescargarReportes || !menuDescargaReportes) {
            return;
        }

        const areaReporte = contDescargaReportes.getAttribute('data-area-reporte') || 'inyeccion';
        const opcionesDescarga = menuDescargaReportes.querySelectorAll('.opcionDescargaReporte');
        let descargaEnCurso = false;
        const configuracionReportes = {
            general: {
                ruta: '/api/' + areaReporte + '/reportes/general',
                nombre: 'general'
            },
            detallado: {
                ruta: '/api/' + areaReporte + '/reportes/detallado',
                nombre: 'detallado'
            }
        };

        function abrirMenuDescarga() {
            menuDescargaReportes.hidden = false;
            btnDescargarReportes.setAttribute('aria-expanded', 'true');

            if (opcionesDescarga.length > 0) {
                opcionesDescarga[0].focus();
            }
        }

        function cerrarMenuDescarga(devolverFoco) {
            menuDescargaReportes.hidden = true;
            btnDescargarReportes.setAttribute('aria-expanded', 'false');

            if (devolverFoco) {
                btnDescargarReportes.focus();
            }
        }

        function alternarMenuDescarga() {
            const menuAbierto = btnDescargarReportes.getAttribute('aria-expanded') === 'true';

            if (menuAbierto) {
                cerrarMenuDescarga(false);
                return;
            }

            abrirMenuDescarga();
        }

        function enfocarOpcion(indiceActual, desplazamiento) {
            if (opcionesDescarga.length === 0) {
                return;
            }

            let nuevoIndice = indiceActual + desplazamiento;

            if (nuevoIndice < 0) {
                nuevoIndice = opcionesDescarga.length - 1;
            } else if (nuevoIndice >= opcionesDescarga.length) {
                nuevoIndice = 0;
            }

            opcionesDescarga[nuevoIndice].focus();
        }

        function mostrarAlertaDescarga(mensaje, clase) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta(mensaje, clase);
            }
        }

        async function obtenerMensajeError(respuesta, nombreReporte) {
            const mensajePredeterminado = `No fue posible generar el reporte ${nombreReporte}.`;
            const tipoContenido = respuesta.headers.get('Content-Type') || '';

            if (tipoContenido.toLowerCase().indexOf('application/json') === -1) {
                return mensajePredeterminado;
            }

            try {
                const resultado = await respuesta.json();

                if (
                    resultado
                    && Array.isArray(resultado.errors)
                    && resultado.errors.length > 0
                    && resultado.errors[0]
                    && resultado.errors[0].message
                ) {
                    return resultado.errors[0].message;
                }
            } catch (error) {
                return mensajePredeterminado;
            }

            return mensajePredeterminado;
        }

        function obtenerNombreArchivo(disposicion, mes, anio, nombreReporte) {
            const mesArchivo = mes < 10 ? `0${mes}` : String(mes);
            const nombrePredeterminado = `reporte_${nombreReporte}_${areaReporte}_${anio}_${mesArchivo}.xlsx`;

            if (!disposicion) {
                return nombrePredeterminado;
            }

            const coincidenciaUtf8 = disposicion.match(/filename\*=UTF-8''([^;]+)/i);

            if (coincidenciaUtf8 && coincidenciaUtf8[1]) {
                try {
                    return decodeURIComponent(coincidenciaUtf8[1].replace(/^"|"$/g, ''));
                } catch (error) {
                    return nombrePredeterminado;
                }
            }

            const coincidenciaSimple = disposicion.match(/filename="?([^";]+)"?/i);

            if (coincidenciaSimple && coincidenciaSimple[1]) {
                return coincidenciaSimple[1];
            }

            return nombrePredeterminado;
        }

        function guardarArchivo(blob, nombreArchivo) {
            const urlTemporal = URL.createObjectURL(blob);
            const enlace = document.createElement('a');
            enlace.href = urlTemporal;
            enlace.download = nombreArchivo.replace(/[\\/:*?"<>|]/g, '_');
            enlace.style.display = 'none';
            document.body.appendChild(enlace);
            enlace.click();
            document.body.removeChild(enlace);

            setTimeout(function () {
                URL.revokeObjectURL(urlTemporal);
            }, 1000);
        }

        async function descargarReporte(opcionDescarga) {
            if (!opcionDescarga || opcionDescarga.disabled || descargaEnCurso) {
                return;
            }

            const tipoReporte = opcionDescarga.getAttribute('data-tipo-reporte');
            const configuracion = tipoReporte ? configuracionReportes[tipoReporte] : null;

            if (!configuracion) {
                mostrarAlertaDescarga('La opción de reporte seleccionada no está disponible.', 'alerta-roja');
                return;
            }

            const parametros = new URLSearchParams(window.location.search);
            const mes = Number(parametros.get('mes'));
            const valorAnio = parametros.get('año') || parametros.get('anio');
            const anio = Number(valorAnio);

            if (!Number.isInteger(mes) || mes < 1 || mes > 12 || !Number.isInteger(anio) || anio < 1900 || anio > 2100) {
                mostrarAlertaDescarga('No se pudo identificar el periodo seleccionado.', 'alerta-roja');
                return;
            }

            const textoOpcion = opcionDescarga.querySelector('span');
            const textoOriginal = textoOpcion ? textoOpcion.textContent : '';

            descargaEnCurso = true;
            btnDescargarReportes.disabled = true;
            btnDescargarReportes.setAttribute('aria-busy', 'true');
            opcionesDescarga.forEach(function (opcion) {
                opcion.disabled = true;
            });
            opcionDescarga.setAttribute('aria-busy', 'true');

            if (textoOpcion) {
                textoOpcion.textContent = 'Generando reporte...';
            }

            try {
                const url = `${configuracion.ruta}?mes=${encodeURIComponent(mes)}&anio=${encodeURIComponent(anio)}`;
                const respuesta = await fetch(url, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    redirect: 'follow'
                });

                if (respuesta.redirected && respuesta.url.indexOf('/perfil') !== -1) {
                    window.location.assign('/perfil');
                    return;
                }

                if (!respuesta.ok) {
                    const mensajeError = await obtenerMensajeError(respuesta, configuracion.nombre);
                    throw new Error(mensajeError);
                }

                const tipoContenido = respuesta.headers.get('Content-Type') || '';

                if (tipoContenido.toLowerCase().indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') === -1) {
                    throw new Error('El servidor no devolvió un libro de Excel válido.');
                }

                const archivo = await respuesta.blob();

                if (!archivo || archivo.size === 0) {
                    throw new Error('El reporte generado está vacío.');
                }

                const nombreArchivo = obtenerNombreArchivo(
                    respuesta.headers.get('Content-Disposition'),
                    mes,
                    anio,
                    configuracion.nombre
                );

                guardarArchivo(archivo, nombreArchivo);
                mostrarAlertaDescarga(`Reporte ${configuracion.nombre} descargado correctamente.`, 'alerta-verde');
            } catch (error) {
                const mensaje = error && error.message
                    ? error.message
                    : `No fue posible descargar el reporte ${configuracion.nombre}.`;
                mostrarAlertaDescarga(mensaje, 'alerta-roja');
            } finally {
                descargaEnCurso = false;
                btnDescargarReportes.disabled = false;
                btnDescargarReportes.removeAttribute('aria-busy');
                opcionesDescarga.forEach(function (opcion) {
                    opcion.disabled = false;
                });
                opcionDescarga.removeAttribute('aria-busy');

                if (textoOpcion) {
                    textoOpcion.textContent = textoOriginal;
                }

                btnDescargarReportes.focus();
            }
        }

        btnDescargarReportes.addEventListener('click', alternarMenuDescarga);

        btnDescargarReportes.addEventListener('keydown', function (evento) {
            if (evento.key !== 'ArrowDown') {
                return;
            }

            evento.preventDefault();
            abrirMenuDescarga();
        });

        menuDescargaReportes.addEventListener('keydown', function (evento) {
            const indiceActual = Array.prototype.indexOf.call(opcionesDescarga, document.activeElement);

            if (evento.key === 'Escape') {
                evento.preventDefault();
                cerrarMenuDescarga(true);
            } else if (evento.key === 'ArrowDown') {
                evento.preventDefault();
                enfocarOpcion(indiceActual, 1);
            } else if (evento.key === 'ArrowUp') {
                evento.preventDefault();
                enfocarOpcion(indiceActual, -1);
            } else if (evento.key === 'Home' && opcionesDescarga.length > 0) {
                evento.preventDefault();
                opcionesDescarga[0].focus();
            } else if (evento.key === 'End' && opcionesDescarga.length > 0) {
                evento.preventDefault();
                opcionesDescarga[opcionesDescarga.length - 1].focus();
            }
        });

        opcionesDescarga.forEach(function (opcionDescarga) {
            opcionDescarga.addEventListener('click', function () {
                cerrarMenuDescarga(true);
                descargarReporte(opcionDescarga);
            });
        });

        contDescargaReportes.addEventListener('focusout', function (evento) {
            const nuevoElementoEnfocado = evento.relatedTarget;

            if (!nuevoElementoEnfocado || !contDescargaReportes.contains(nuevoElementoEnfocado)) {
                cerrarMenuDescarga(false);
            }
        });

        document.addEventListener('click', function (evento) {
            if (!contDescargaReportes.contains(evento.target)) {
                cerrarMenuDescarga(false);
            }
        });
    }

    contenedoresDescarga.forEach(inicializarDescargaReportes);
});
